/**
 * Generated by orval v6.31.0 🍺
 * Do not edit manually.
 * Zäkra API 1.0
 * REST API for Zäkra
 * OpenAPI spec version: v1
 */

export type RoutePlanFeedbackRoundEnum =
  (typeof RoutePlanFeedbackRoundEnum)[keyof typeof RoutePlanFeedbackRoundEnum];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RoutePlanFeedbackRoundEnum = {
  Evening: 0,
  Morning: 1,
  Afternoon: 2,
  Forenoon: 3,
} as const;
